// main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from './context/ThemeContext';
import App from './App.jsx';
import './styles/globals.css';

// This ensures the element exists before rendering
const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error("❌ 'root' element not found in index.html");
} else {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </React.StrictMode>
  );
}
